/**
 * Local storage Helper class
 */
export default class LocalStorage {
    /**
     * Set Local storage
     * @param {*} key
     * @param {*} data
     * @returns items by key
     */
    setItem(key, data) {
        window.localStorage.setItem(`${key}`, JSON.stringify(data));
        return this.getItem(`${key}`);
    }

    /**
     * Get storage items by key
     * @param {*} key
     * @returns
     */
    getItem(key) {
        return JSON.parse(window.localStorage.getItem(`${key}`));
    }

    /**
     * Remove storage by key
     * @param {*} key
     * @returns items by key
     */
    removeItem(key) {
        window.localStorage.removeItem(key);
        return this.getItem(key);
    }

    /**
     * Get Storage key by index
     * @param {*} index
     * @returns
     */
    getKey(index) {
        return window.localStorage.key(`${index}`);
    }
}
